import uaParser, { IBrowser, IDevice } from 'ua-parser-js';
import { getContext } from '@fiverr-private/fiverr_context';

const yieldToMainThread = async (): Promise<void> =>
    new Promise((resolve) => {
        setTimeout(resolve, 200);
    });

const shouldDelayRedirect = () => {
    const { userAgent } = getContext();
    const { browser, device } = uaParser(userAgent);

    const browsers: IBrowser['name'][] = ['Chrome', 'Chromium'];
    const devices: IDevice['type'][] = ['mobile', 'tablet'];

    const isEligibleBrowser = browsers.includes(browser.name);
    const isEligibleDevice = devices.includes(device.type);

    return isEligibleBrowser && isEligibleDevice;
};

export const redirectOrPageReload = async (url?: string | null): Promise<void> => {
    const withDelay = shouldDelayRedirect();

    if (withDelay) await yieldToMainThread();

    if (url) {
        window.location.assign(url);
        return;
    }

    window.location.reload();
};
